<template>
  <div
    class="br-subleft overflow-y-auto"
    :data-min="sideStatus"
    style="z-index: 1"
  >
    <div>
      <h6
        class="
          tx-uppercase tx-14 tx-mont tx-spacing-1
          mg-t-10
          pd-x-10
          tx-white-7
        "
      >
        {{ $t("offer.条件筛选") }}
      </h6>
      <div class="mg-t-20 pd-x-10 mg-b-40">
        <div class="mg-b-10 form-group">
          <select-distributor
            class="mg-b-10"
            :noLike="true"
            :key_word="keyDistributorName"
            @changeKeyword="changeName"
            @keywordEnter="filtrateName"
            @keywordFilter="filtrateNameDefault"
          />
        </div>
        <div class="mg-b-20 form-group">
          <select
            class="form-control form-control-dark pd-y-0"
            @change="filtrate"
            v-model="keyStatus"
          >
            <option value="">{{ $t("offer.报价单状态") }}</option>
            <template v-for="(status, key, index) in offerStatus">
              <option v-if="key != 1" :key="index" :value="key">
                {{ $t(status) }}
              </option>
            </template>
          </select>
        </div>
      </div>
    </div>
    <button
      class="
        btn btn-primary btn-block
        tx-uppercase tx-11 tx-spacing-2 tx-medium
      "
      @click="filtrate"
    >
      {{ $t("offer.筛 选") }}
    </button>
  </div>
</template>

<script>
import SelectDistributor from "@components/supplier/select-distributor-2.vue"; //客户搜索
export default {
  props: ["sideStatus", "distributor_name", "status"],
  data() {
    return {
      keyDistributorName: "",
      keyDistributorId: "",
      keyDistributorName1: "",
      keyDistributorId1: "",
      keyStatus: this.$route.query.status ? this.$route.query.status : "",
      offerStatus: arrDict.offerStatus,
    };
  },
  components: {
    "select-distributor": SelectDistributor,
  },
  mounted() {
    $(".overflow-y-auto").perfectScrollbar();
  },
  watch: {
    distributor_name: function () {
      this.keyDistributorName = this.distributor_name;
      this.keyDistributorName1 = this.distributor_name;
    },
    status: function () {
      this.keyStatus = this.status;
    },
  },
  methods: {
    sideChangeStatus() {
      //边栏状态改变
      this.$emit("changeStatus");
    },
    changeName(name, id) {
      this.keyDistributorName = name;
      this.keyDistributorId = id;
    },
    filtrateName(name, id) {
      if (name && name == this.distributor_name) {
        this.filtrate();
        return;
      }
      if (!id || id == "e999") {
        if (id == "e999") ShowTip(this.$t("offer.没有匹配的供应商"), "danger");
        this.keyDistributorName = "";
        this.keyDistributorId = "";
      } else {
        //清空按供应商名
        this.keyDistributorName = name;
        this.keyDistributorId = id;
      }
      this.filtrate();
    },
    filtrateNameDefault(name, id) {
      this.keyDistributorName1 = name;
      this.keyDistributorId1 = id;
    },
    filtrate() {
      if (!this.keyDistributorId) {
        this.keyDistributorName = "";
        this.keyDistributorId = this.keyDistributorId1;
        this.keyDistributorName = this.keyDistributorName1;
        this.$emit(
          "filtrate",
          this.keyStatus,
          this.keyDistributorName1,
          this.keyDistributorId1
        );
      } else {
        if (!this.keyDistributorId1) {
          this.$emit(
            "filtrate",
            this.keyStatus,
            this.keyDistributorName,
            this.keyDistributorId
          );
        } else {
          this.keyDistributorName = "";
          this.keyDistributorId = this.keyDistributorId1;
          this.keyDistributorName = this.keyDistributorName1;
          this.$emit(
            "filtrate",
            this.keyStatus,
            this.keyDistributorName1,
            this.keyDistributorId1
          );
        }
      }
    },
  },
};
</script>
